import { jsx as n } from "react/jsx-runtime";
import * as l from "react";
import { a as $, c as T } from "./index-eoE_jzLb.js";
import { P as p, c as D } from "./index-D8UDu4KA.js";
import { R as G, I as W, c as N } from "./index-ClOoRiow.js";
import { P as K } from "./index-CRtCLpV2.js";
import { u as B } from "./index-Dn75bnUs.js";
import { u as j } from "./index-n3ZmtxN0.js";
import { c as I } from "./index-BNmRGtA6.js";
import { c as g } from "./clsx-OuTLNxxd.js";
import './Tabs.css';var h = "Tabs", [q] = D(h, [
  N
]), R = N(), [z, C] = q(h), A = l.forwardRef(
  (a, o) => {
    const {
      __scopeTabs: t,
      value: e,
      onValueChange: r,
      defaultValue: d,
      orientation: s = "horizontal",
      dir: u,
      activationMode: v = "automatic",
      ...m
    } = a, c = B(u), [i, b] = $({
      prop: e,
      onChange: r,
      defaultProp: d
    });
    return /* @__PURE__ */ n(
      z,
      {
        scope: t,
        baseId: j(),
        value: i,
        onValueChange: b,
        orientation: s,
        dir: c,
        activationMode: v,
        children: /* @__PURE__ */ n(
          p.div,
          {
            dir: c,
            "data-orientation": s,
            ...m,
            ref: o
          }
        )
      }
    );
  }
);
A.displayName = h;
var P = "TabsList", w = l.forwardRef(
  (a, o) => {
    const { __scopeTabs: t, loop: e = !0, ...r } = a, d = C(P, t), s = R(t);
    return /* @__PURE__ */ n(
      G,
      {
        asChild: !0,
        ...s,
        orientation: d.orientation,
        dir: d.dir,
        loop: e,
        children: /* @__PURE__ */ n(
          p.div,
          {
            role: "tablist",
            "aria-orientation": d.orientation,
            ...r,
            ref: o
          }
        )
      }
    );
  }
);
w.displayName = P;
var x = "TabsTrigger", L = l.forwardRef(
  (a, o) => {
    const { __scopeTabs: t, value: e, disabled: r = !1, ...d } = a, s = C(x, t), u = R(t), v = M(s.baseId, e), m = S(s.baseId, e), c = e === s.value;
    return /* @__PURE__ */ n(
      W,
      {
        asChild: !0,
        ...u,
        focusable: !r,
        active: c,
        children: /* @__PURE__ */ n(
          p.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": c,
            "aria-controls": m,
            "data-state": c ? "active" : "inactive",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            id: v,
            ...d,
            ref: o,
            onMouseDown: T(a.onMouseDown, (i) => {
              !r && i.button === 0 && i.ctrlKey === !1 ? s.onValueChange(e) : i.preventDefault();
            }),
            onKeyDown: T(a.onKeyDown, (i) => {
              [" ", "Enter"].includes(i.key) && s.onValueChange(e);
            }),
            onFocus: T(a.onFocus, () => {
              const i = s.activationMode !== "manual";
              !c && !r && i && s.onValueChange(e);
            })
          }
        )
      }
    );
  }
);
L.displayName = x;
var V = "TabsContent", k = l.forwardRef(
  (a, o) => {
    const { __scopeTabs: t, value: e, forceMount: r, children: d, ...s } = a, u = C(V, t), v = M(u.baseId, e), m = S(u.baseId, e), c = e === u.value, i = l.useRef(c);
    return l.useEffect(() => {
      const b = requestAnimationFrame(() => i.current = !1);
      return () => cancelAnimationFrame(b);
    }, []), /* @__PURE__ */ n(K, { present: r || c, children: ({ present: b }) => /* @__PURE__ */ n(
      p.div,
      {
        "data-state": c ? "active" : "inactive",
        "data-orientation": u.orientation,
        role: "tabpanel",
        "aria-labelledby": v,
        hidden: !b,
        id: m,
        tabIndex: 0,
        ...s,
        ref: o,
        style: {
          ...a.style,
          animationDuration: i.current ? "0s" : void 0
        },
        children: b && d
      }
    ) });
  }
);
k.displayName = V;
function M(a, o) {
  return `${a}-trigger-${o}`;
}
function S(a, o) {
  return `${a}-content-${o}`;
}
var H = A, _ = w, E = L, F = k;
const O = "_tabsTrigger_1aik9_32", J = "_tabsList_1aik9_48", Q = "_tabsContent_1aik9_150", U = "_fullWidth_1aik9_158", f = {
  tabsTrigger: O,
  tabsList: J,
  tabsContent: Q,
  fullWidth: U
}, la = H, y = I("", {
  variants: {
    variant: {
      default: f.tabsList,
      block: f.tabsList
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), X = I("", {
  variants: {
    variant: {
      default: f.tabsTrigger,
      block: f.tabsTrigger
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Y = l.forwardRef(
  ({ className: a, fullWidth: o = !1, variant: t = "default", ...e }, r) => t === "block" ? /* @__PURE__ */ n("div", { className: g(y({ variant: t }), a), "data-cxy-name": "tabs", "data-variant": t, children: /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n(_, { ref: r, ...e }) }) }) : /* @__PURE__ */ n(
    _,
    {
      className: g(y({ variant: t }), a, { [f.fullWidth]: o }),
      "data-variant": t,
      ref: r,
      ...e
    }
  )
);
Y.displayName = _.displayName;
const Z = l.forwardRef(
  ({ className: a, variant: o = "default", ...t }, e) => /* @__PURE__ */ n(
    E,
    {
      className: g(X({ variant: o }), a),
      "data-variant": o,
      ref: e,
      ...t
    }
  )
);
Z.displayName = E.displayName;
const aa = l.forwardRef(({ className: a, ...o }, t) => /* @__PURE__ */ n(F, { className: g(f.tabsContent, a), ref: t, ...o }));
aa.displayName = F.displayName;
export {
  la as T,
  aa as a,
  Y as b,
  Z as c
};
